import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import ProductcompositionDashboard from '../ProductcompositionDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductcompositionPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < ProductcompositionDashboard />
    )

}